import React from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { AuthProvider } from "./context/AuthContext";
import ProtectedRoute from "./components/ProtectedRoute";
import FeatureRoute, { HomeRedirect, SettingsRoute } from "./components/FeatureRoute";
import Layout from "./components/Layout";
import LoginPage from "./pages/LoginPage";
import DashboardPage from "./pages/DashboardPage";
import AdvertisersPage from "./pages/AdvertisersPage";
import ClientDetailPage from "./pages/ClientDetailPage";
import BookingsPage from "./pages/BookingsPage";
import EditionsPage from "./pages/EditionsPage";
import FlatplanPage from "./pages/FlatplanPage";
import SettingsPage from "./pages/SettingsPage";
import AccountingPage from "./pages/AccountingPage";
import AdMatrixPage from "./pages/AdMatrixPage";
import SalesPage from "./pages/SalesPage";
import PlannerPage from "./pages/PlannerPage";
import DigitalPage from "./pages/DigitalPage";
import OrdersPage from "./pages/OrdersPage";
import PropertiesPage from "./pages/PropertiesPage";
import { Toaster } from "./components/ui/toaster";

function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <Routes>
          {/* Public routes */}
          <Route path="/login" element={<LoginPage />} />
          
          {/* Protected routes */}
          <Route
            path="/dashboard"
            element={
              <ProtectedRoute>
                <Layout>
                  <FeatureRoute feature="dashboard">
                    <DashboardPage />
                  </FeatureRoute>
                </Layout>
              </ProtectedRoute>
            }
          />
          <Route
            path="/advertisers"
            element={
              <ProtectedRoute>
                <Layout>
                  <AdvertisersPage />
                </Layout>
              </ProtectedRoute>
            }
          />
          <Route
            path="/advertisers/:clientId"
            element={
              <ProtectedRoute>
                <Layout>
                  <ClientDetailPage />
                </Layout>
              </ProtectedRoute>
            }
          />
          <Route
            path="/bookings"
            element={
              <ProtectedRoute>
                <Layout>
                  <FeatureRoute feature="bookings">
                    <BookingsPage />
                  </FeatureRoute>
                </Layout>
              </ProtectedRoute>
            }
          />
          <Route
            path="/editions"
            element={
              <ProtectedRoute>
                <Layout>
                  <FeatureRoute feature="editions">
                    <EditionsPage />
                  </FeatureRoute>
                </Layout>
              </ProtectedRoute>
            }
          />
          <Route
            path="/flatplan/:editionId"
            element={
              <ProtectedRoute>
                <Layout>
                  <FeatureRoute feature="editions">
                    <FlatplanPage />
                  </FeatureRoute>
                </Layout>
              </ProtectedRoute>
            }
          />
          <Route
            path="/settings"
            element={
              <ProtectedRoute>
                <SettingsRoute>
                  <Layout>
                    <SettingsPage />
                  </Layout>
                </SettingsRoute>
              </ProtectedRoute>
            }
          />
          <Route
            path="/accounting"
            element={
              <ProtectedRoute>
                <Layout>
                  <FeatureRoute feature="accounting">
                    <AccountingPage />
                  </FeatureRoute>
                </Layout>
              </ProtectedRoute>
            }
          />
          <Route
            path="/ad-matrix"
            element={
              <ProtectedRoute>
                <Layout>
                  <FeatureRoute feature="ad_matrix">
                    <AdMatrixPage />
                  </FeatureRoute>
                </Layout>
              </ProtectedRoute>
            }
          />
          <Route
            path="/sales"
            element={
              <ProtectedRoute>
                <Layout>
                  <SalesPage />
                </Layout>
              </ProtectedRoute>
            }
          />
          <Route
            path="/planner"
            element={
              <ProtectedRoute>
                <Layout>
                  <PlannerPage />
                </Layout>
              </ProtectedRoute>
            }
          />
          <Route
            path="/digital"
            element={
              <ProtectedRoute>
                <Layout>
                  <FeatureRoute feature="digital">
                    <DigitalPage />
                  </FeatureRoute>
                </Layout>
              </ProtectedRoute>
            }
          />
          <Route
            path="/properties"
            element={
              <ProtectedRoute>
                <Layout>
                  <PropertiesPage />
                </Layout>
              </ProtectedRoute>
            }
          />
          <Route
            path="/orders"
            element={
              <ProtectedRoute>
                <Layout>
                  <FeatureRoute feature="orders">
                    <OrdersPage />
                  </FeatureRoute>
                </Layout>
              </ProtectedRoute>
            }
          />
          
          {/* Root and unknown paths go to the user's home screen
              (Dashboard, or Sales when the property has no Dashboard) */}
          <Route path="/" element={<HomeRedirect />} />
          <Route path="*" element={<HomeRedirect />} />
        </Routes>
        <Toaster />
      </BrowserRouter>
    </AuthProvider>
  );
}

export default App;
